import {
    Box,
    Button,
    Checkbox,
    Heading,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    useDisclosure
} from '@chakra-ui/react'
import { useAuthContext } from 'contexts/auth'
import jwt_decode from 'jwt-decode'
import { AuthTokens } from 'models'
import { useState } from 'react'
import { agreeUser } from 'services/users'
import { termsOfUse } from 'utils/termsOfUse'

interface TextTerms {
    title?: string
    text: string
    subtitle?: string
}

const Agree: React.FC = () => {
    const { currentUser } = useAuthContext()
    const decoded =
        currentUser && (jwt_decode(currentUser.idToken) as AuthTokens)

    const { isOpen, onClose } = useDisclosure({
        defaultIsOpen: !decoded?.aceite
    })
    const [agree, setAgree] = useState(false)

    const handleAccepted = () => {
        decoded &&
            agreeUser(decoded['custom:usuario_guid']).then(() => onClose())
    }

    const TextCard = (props: { content: TextTerms }) => {
        return (
            <>
                {props.content.title && (
                    <Text
                        pt="30px"
                        pb={props.content.subtitle ? '0px' : '30px'}
                        fontWeight="bold"
                        fontSize="14px"
                    >
                        {props.content.title}
                    </Text>
                )}
                {props.content.subtitle && (
                    <Text pb="30px" ml="20px" fontWeight="bold" fontSize="14px">
                        {props.content.subtitle}
                    </Text>
                )}
                <Box
                    textAlign="justify"
                    className="text"
                    dangerouslySetInnerHTML={{
                        __html: `${props.content.text}`
                    }}
                />
            </>
        )
    }

    return (
        <Modal
            closeOnEsc={false}
            closeOnOverlayClick={false}
            onClose={onClose}
            isOpen={isOpen}
            scrollBehavior="inside"
            size="4xl"
        >
            <ModalOverlay />
            <ModalContent mx={6}>
                <ModalHeader
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    minH="88px"
                >
                    <Heading fontSize="xl" textAlign="center">
                        Termos de uso e privacidade da plataforma de registro
                        ERDOC
                    </Heading>
                </ModalHeader>
                <ModalBody p="00px 33px 33px">
                    {termsOfUse.terms_of_use.map((t, k) => (
                        <TextCard key={k} content={t} />
                    ))}
                    {termsOfUse.privacy_policy.map((t, k) => (
                        <TextCard key={k} content={t} />
                    ))}
                </ModalBody>
                <ModalFooter
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    minH="88px"
                    borderTop="1px"
                    borderColor="gray.100"
                    shadow="md"
                >
                    <Checkbox
                        size="lg"
                        colorScheme="primary"
                        borderColor="primary.500"
                        checked={agree}
                        onChange={() => setAgree(old => !old)}
                    >
                        <Text fontSize="14px" maxW="350px">
                            <strong>Li e concordo</strong> com os{' '}
                            <strong>termos de uso</strong> e a{' '}
                            <strong>política de privacidade</strong>{' '}
                            apresentadas no documento a cima.
                        </Text>
                    </Checkbox>
                    <Button
                        isDisabled={!agree}
                        colorScheme="primary"
                        onClick={handleAccepted}
                    >
                        Acessar
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default Agree
